/** 実装済み 4 カテゴリ。BE `equipment-alert-category.ts` の IMPLEMENTED と同期すること。 */
export const ALERT_CATEGORY_KEYS = ['REPLACEMENT_DUE', 'TO_BE_ASSIGNED', 'VIOLATED_ASSIGNMENT', 'ALUMNI'] as const;
export type AlertCategoryKey = (typeof ALERT_CATEGORY_KEYS)[number];

/** アラートタブ初回表示・不正 category クエリ時の既定カテゴリ */
export const DEFAULT_ALERT_CATEGORY = 'TO_BE_ASSIGNED' as const satisfies AlertCategoryKey;

/** 品目別集約タブで表示可能なカテゴリ（design.md D8 / equipment-alert spec） */
const ITEM_AGGREGATE_ALERT_CATEGORY_KEYS = ['REPLACEMENT_DUE', 'TO_BE_ASSIGNED', 'VIOLATED_ASSIGNMENT', 'ALUMNI'] as const satisfies readonly AlertCategoryKey[];
export type ItemAggregateAlertCategoryKey = (typeof ITEM_AGGREGATE_ALERT_CATEGORY_KEYS)[number];
export function supportsItemAggregateView(category: AlertCategoryKey): category is ItemAggregateAlertCategoryKey {
  return (ITEM_AGGREGATE_ALERT_CATEGORY_KEYS as readonly string[]).includes(category);
}